import React, { useEffect, useState } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import styled from 'styled-components'
import { Col, Row, Space } from 'antd'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { DataList, ListReq } from 'Store/partner-qr/types'
import { selectList, selectListEvent } from 'Store/partner-qr/selector'
import { formatDateTime, getAgentStatus, isFilter, toDateQuery } from 'helpers/format'
import { StatusTag } from 'Components/utilities'
import { TableListPage } from 'Components/common/Table'
import { ActionButton, PrimaryButton } from 'Components/button'
import HomePageLayout from 'Pages/Layout/PageLayout'
import { Pagination } from 'Components/Pagination'
import { RangeDateItem, SearchInput, SelectItem } from 'Components/form'
import LinkText from 'Components/text/LinkText'
import { Theme } from 'Components/common'
import { cloneDeep } from 'lodash'
import { CheckOutlined, FileSearchOutlined } from '@ant-design/icons'
import { menuPartnerQr, AgentApproveStatus } from 'helpers/constanst'
import Detail from '../../AdminQr/QrcodePartner/detail'
import { selectLoginData } from 'Store/user/selector'
import { MyTheme } from 'Components/common/Theme'
import { getQrPartnerListAPI } from 'Store/partner-qr/api'

type Props = {} & RouteComponentProps & ReduxProps

const QrPartner: React.FunctionComponent<Props> = props => {
  const { listEvent, dataList, loginData } = props
  const dispatch = useDispatch()
  const [resetFilter, setResetFilter] = useState(false)
  const [selected, setSelected] = useState({} as DataList)
  const [drawer, setDrawer] = useState(false)

  const initFilter = {
    start_date: '',
    end_date: '',
    merchant_id: 0,
    keyword: '',
    status: '',
    partner_status: '',
  }
  const [filter, setFilter] = useState(cloneDeep(initFilter))
  const [pagination, setPagination] = useState({
    Page: 1,
    RowPerPage: 10,
  })
  const meta = dataList.meta
  const datas = dataList.data

  const onGetDataList = (): void => {
    const req: ListReq = {
      page: pagination.Page,
      per_page: pagination.RowPerPage,
      status: filter.status,
      partner_status: filter.partner_status,
      keyword: filter.keyword,
      start_date: filter.start_date ? toDateQuery(filter.start_date) : '',
      end_date: filter.end_date ? toDateQuery(filter.end_date) : '',
    }
    dispatch(getQrPartnerListAPI(req, loginData?.access_token || ''))
  }

  useEffect(() => {
    if (loginData?.access_token) {
      onGetDataList()
    }
  }, [pagination])

  useEffect(() => {
    if (resetFilter) {
      onGetDataList()
      setResetFilter(false)
    }
  }, [resetFilter])

  const onClickSearch = () => {
    pagination.Page = 1
    setPagination({ ...pagination })
  }

  useEffect(() => {
    if (pagination.Page === 1) return
    pagination.Page = 1
    pagination.RowPerPage = 10
    setPagination({ ...pagination })
  }, [])

  const onFilter = (key: string, val: string) => {
    setFilter({
      ...filter,
      [key]: val,
    })
  }

  const onOpenDrawer = () => {
    setDrawer(true)
  }

  const onCloseDrawer = () => {
    setDrawer(false)
  }

  const onClickApprove = (item: DataList) => {
    setSelected(item)
    onOpenDrawer()
  }

  const onSuccess = () => {
    // onCloseDrawer()
    onGetDataList()
  }

  const onResetFilter = () => {
    setFilter(cloneDeep({ ...initFilter }))
    setResetFilter(true)
  }

  const handleChangeDate = (statDate: string, endDate: string) => {
    setFilter({
      ...filter,
      start_date: statDate,
      end_date: endDate,
    })
  }

  const renderStatus = (value: any) => {
    const result = getAgentStatus(value)
    return <StatusTag color={result.color} text={result.text} />
  }

  const renderAgentName = (value: any, record: DataList) => {
    return <Link onClick={() => onClickApprove(record)}>{value}</Link>
  }

  const renderActionButton = (text: string, record: DataList) => {
    const isPending = record?.partner_status === AgentApproveStatus.PENDING
    // if (!isPendding) return
    return (
      <Row justify="center" gutter={[8, 8]}>
        {isPending ? (
          <Col>
            <ActionButton
              text=""
              icon={<CheckOutlined />}
              label="อนุมัติ"
              action="default"
              onClick={() => onClickApprove(record)}
            />
          </Col>
        ) : (
          <Col>
            <ActionButton
              text=""
              icon={<FileSearchOutlined />}
              label="ดูข้อมูล"
              action="default"
              onClick={() => onClickApprove(record)}
            />
          </Col>
        )}
      </Row>
    )
  }

  const columns = [
    {
      title: '#',
      dataIndex: 'id',
      key: 'id',
      width: '40px',
      render: (value: any, record: any, index: number) => {
        return index + 1 + (pagination.Page - 1) * pagination.RowPerPage
      },
    },
    {
      title: 'รหัสตัวแทน',
      dataIndex: 'agent_code',
      key: 'agent_code',
      render: renderAgentName,
    },
    {
      title: 'Partner QR Name',
      dataIndex: 'qr_name',
      key: 'qr_name',
      //render: renderAgentName,
    },
    {
      title: 'ชื่อ',
      dataIndex: 'first_name',
      key: 'first_name',
    },
    {
      title: 'นามสกุล',
      dataIndex: 'last_name',
      key: 'last_name',
    },
    {
      title: 'อีเมล',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'หัวหน้างาน',
      dataIndex: 'parent_agent_code',
      key: 'parent_agent_code',
      render: (val: string) => val || '-',
    },
    {
      title: 'วันที่สร้าง',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (val: string) => formatDateTime(val),
    },
    {
      title: 'สถานะ',
      dataIndex: 'partner_status',
      key: 'partner_status',
      width: '100px',
      render: renderStatus,
    },
    {
      title: '',
      dataIndex: 'submit',
      key: 'submit',
      width: '80px',
      render: renderActionButton,
    },
  ]

  const DetailDrawer = (
    <Detail
      id={selected?.id || 0}
      visible={drawer}
      onCloseDrawer={onCloseDrawer}
      onSuccess={onSuccess}
      isAdmin={true}
    />
  )

  const FilterContent = (
    <FilterWrapper>
      <Row justify="start" align="bottom" gutter={[16, 16]}>
        <Col xs={24} md={7}>
          <SearchInput
            name="keyword"
            placeholder="ค้นหาชื่อ, รหัสตัวแทน"
            value={filter.keyword}
            onChange={onFilter}
          />
        </Col>
        {/* <Col xs={24} md={4}>
          <SelectItem
            name={'status'}
            label={''}
            isRequired={true}
            value={filter.status}
            menu={menuStatus}
            placeHolder={'สถานะผู้ใช้งาน'}
            onChange={(val: any): void => onFilter('status', val)}
          />
        </Col> */}
        <Col xs={24} md={4}>
          <SelectItem
            name={'partner_status'}
            label={''}
            isRequired={true}
            value={filter.partner_status}
            menu={menuPartnerQr}
            placeHolder={'สถานะอนุมัติ'}
            onChange={(val: any): void => onFilter('partner_status', val)}
          />
        </Col>
        <Col xs={24} md={6}>
          <RangeDateItem
            placeHolder={['วันที่สร้างเริ่มต้น', 'สิ้นสุด']}
            onChange={handleChangeDate}
            startDate={filter.start_date}
            endDate={filter.end_date}
          />
        </Col>
        <Col>
          <Space size="middle" align="center">
            <PrimaryButton text="ค้นหา" btnType="Cancel" onClick={onClickSearch} key="search" />
            {isFilter(filter) && (
              <LinkText color={Theme.colors.primary} onClick={onResetFilter}>
                ล้างการค้นหา
              </LinkText>
            )}
          </Space>
        </Col>
      </Row>
    </FilterWrapper>
  )

  const PaginationContent = (
    <Pagination
      currentPage={pagination.Page}
      totalRows={meta?.totalCount || 0}
      perPage={pagination.RowPerPage}
      onClickPage={(page: number) => {
        pagination.Page = page
        setPagination({ ...pagination })
      }}
      onChangeNumber={(number: number) => {
        pagination.RowPerPage = number
        setPagination({ ...pagination })
      }}
    />
  )

  return (
    <>
      <HomePageLayout selected="partner-qrcode" title="อนุมัติ Partner QR Code" label="">
        {FilterContent}
        <TableListPage
          columns={columns}
          datas={datas}
          isLoading={listEvent.IsLoading}
          paginationContent={null}
          scrollX={800}
        />
        {PaginationContent}
        {/* {LoadingModal} */}
        {DetailDrawer}
      </HomePageLayout>
    </>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    dataList: selectList(state),
    listEvent: selectListEvent(state),
    loginData: selectLoginData(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(QrPartner)

const FilterWrapper = styled.div`
  padding: 10px 0 5px 0;
`

const Link = styled(LinkText)`
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.bold};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
  //text-decoration: none;
`
